<template>
  <div>
    <div class="max-w-sm">
      <Input
        :label="label"
        type="password"
        @change="input"
      />
    </div>
  </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import Input from '@/app/shared/components/form/inputs/input.vue';

export default {

  components: {
    Input,
  },

  props: {
    label: {
      type: String,
      default: 'Password',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      password: ' ',
    };
  },

  mounted() {
    this.password = '';
    this.$emit('errors', this.getErrors());
  },

  methods: {
    input(input) {
      this.password = input;
      this.$emit('input', input);
      this.$emit('errors', this.getErrors());
    },

    getErrors() {
      const errors = [];

      if (this.required) {
        if (!this.$v.password.required) {
          errors.push('A password is required.');
        }
      }

      if (!this.$v.password.minLength) {
        errors.push('Password must be at least 6 characters.');
      }

      return errors;
    },
  },

  validations() {
    return {
      password: { required, minLength: minLength(6) },
    };
  },
};
</script>
